var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 19.25C3.89375 19.25 3.48163 19.0785 3.13863 18.7355C2.79563 18.3925 2.62442 17.9807 2.625 17.5V5.25H4.375V17.5H14V19.25H4.375ZM7.875 15.75C7.39375 15.75 6.98163 15.5785 6.63863 15.2355C6.29563 14.8925 6.12442 14.4807 6.125 14V3.5C6.125 3.01875 6.2965 2.60663 6.6395 2.26363C6.9825 1.92063 7.39433 1.74942 7.875 1.75H15.75C16.2313 1.75 16.6434 1.9215 16.9864 2.2645C17.3294 2.6075 17.5006 3.01933 17.5 3.5V14C17.5 14.4813 17.3285 14.8934 16.9855 15.2364C16.6425 15.5794 16.2307 15.7506 15.75 15.75H7.875ZM7.875 14H15.75V3.5H7.875V14Z",
    fill: "#666668"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.188691475d42ed0ce90fd60acae0d3eb.svg";
export { ForwardRef as ReactComponent };